import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";

export interface StatusCardProps {
  icon: ReactNode;
  title: string;
  body: string;
  /** Extra line shown below `body`, e.g. the 404 sign-in hint. */
  hint?: string;
}

/** Centered icon + copy card used for every non-playing, non-VOD state on the watch pages. */
export function StatusCard({ icon, title, body, hint }: StatusCardProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white/70">
        {icon}
      </div>
      <h1 className="text-base font-semibold text-white">{title}</h1>
      <p className="max-w-sm text-sm text-white/60">{body}</p>
      {hint && <p className="max-w-sm text-xs text-white/40">{hint}</p>}
    </div>
  );
}

/** Centered spinner + single line, used for both the initial load and "processing" states. */
export function LoadingRow({ label }: { label: string }) {
  return (
    <div role="status" className="flex flex-1 items-center justify-center gap-2 text-white/70">
      <Loader2 className="h-6 w-6 animate-spin" />
      <span>{label}</span>
    </div>
  );
}
